import React, { useState } from 'react';
import { Dialog, Grid, ListItemText, Card, Typography, Button } from '@material-ui/core';
import { UploadButton } from '../../../../components/UploadButtonComponent';
import EditIcon from '@material-ui/icons/Edit';
import { userLanguage } from '../../../../core/AuthContext';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';
import { ErrorComponent, LoadingSpinner, SectionCard, SvgDisplay } from '../../../../components';
import SymbolUpdateDialog from '../SymbolUpdateDialog/SymbolUpdateDialog';
import { GQLParty, GQLSymbolAsset } from '@jewelutions/core-crm-server-api-client-domain';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { downloadFromUrl, saveCsvFile } from '../../../../core/utils';
import { Download } from 'react-feather';

interface IProps {
  party: GQLParty;
  symbolAsset: GQLSymbolAsset;
  reloadSymbols: () => void;
}

const SymbolsDetails: React.FC<IProps> = ({ party, symbolAsset, reloadSymbols }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [file, setFile] = useState(null as any);
  const [errorComponentState, setErrorComponentState] = useState(false);

  const [uploadMedia, { error, loading }] = GQLOperationBuilder.symbol.importSymbolMedia();

  if (loading) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <Dialog open={true} maxWidth="md" aria-labelledby="add-font">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => uploadMedia({ variables: { file, symbolId: symbolAsset.id } })}
          details={error?.stack}
          message={error?.message}
        />
      </Dialog>
    );

  const importMedia = (e: File) => {
    setFile(e);
    uploadMedia({ variables: { file: e, symbolId: symbolAsset.id } });
  };

  return (
    <Card style={{ alignItems: 'center', padding: '8px' }} variant="outlined">
      <div style={{ display: 'flex' }}>
        <Typography style={{ marginRight: '2px' }} variant="h4">
          {symbolAsset.symbol.title[userLanguage]}
        </Typography>
        <EditIcon fontSize="small" style={{ cursor: 'pointer' }} onClick={() => setShowDialog(true)} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px' }}>
        <ListItemText primary="Symbol name" secondary={symbolAsset.symbol.title[userLanguage]} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px' }}>
        <ListItemText primary="Symbol description" secondary={symbolAsset.symbol.description[userLanguage]} />
      </div>

      {symbolAsset.symbol.media?.url && (
        <SvgDisplay style={{ width: '128px', height: '128px' }} url={symbolAsset.symbol.media?.url} />
      )}
      {!symbolAsset.symbol.media?.url && (
        <img height={40} style={{ color: 'red' }} src={'/images/x-mark-128.png'}></img>
      )}
      <PublishableStatusComponent text="Publishable" status={symbolAsset.isPublishable} />
      <PublishableStatusComponent text="Media present" status={symbolAsset.hasMediaValid} />

      <Grid item justify="center" container style={{ marginTop: '10px' }}>
        <UploadButton
          id={`symbolDetailsImportNewMedia1_${symbolAsset.id}`}
          fileTypesAsCsv={'.svg'}
          importButtonLabel={'Import Media'}
          onFileSelected={importMedia}
        />
      </Grid>

      {showDialog && (
        <SymbolUpdateDialog
          dialogId="editSymbolDialog"
          symbolAsset={symbolAsset}
          party={party}
          onClose={val => setShowDialog(val)}
        ></SymbolUpdateDialog>
      )}
    </Card>
  );
};
export default SymbolsDetails;
